module.exports = __webpack_public_path__ + "static/videoHeader-96d09ba9f4e0e3eb7ad5093322ff30ed.mp4";